export default {
      id: "wedo-4-usage",
      viewBox: "0 0 50 50",
      url: "/" + "assets/sprite.svg#wedo-4",
      toString: function () {
        return this.url;
      }
    }